import ky from 'ky'

import { createInstance } from './api'
import { backoffice } from './endpoint'

const instance = createInstance(backoffice())

export const { post, put, get, patch } = instance

export const api: typeof ky = instance
